import { Route } from '@angular/router'

/**
 * Routes for device-related components.

 * - **Device List:** When navigating to the base path (`''`), the `DeviceListComponent` is loaded.
 * - **Device Details:** When navigating to the `/details` path, the `DeviceDetailsComponent` is loaded.

 * @export
 * @constant DEVICES
 */
export const DEVICES: Route[] = [
    {
        path: '',
        loadComponent: () =>
            import('../features/devices/devices.page').then((c) => c.DevicesPage),
    },
    {
        path: 'new',
        loadComponent: () =>
            import('../features/devices/device-edit/device-edit.page').then(
                (c) => c.DeviceEditPage
            ),
    },
    {
        path: 'edit/:id',
        loadComponent: () =>
            import('../features/devices/device-edit/device-edit.page').then(
                (c) => c.DeviceEditPage
            ),
    },
    {
        path: 'details',
        loadComponent: () =>
            import('../devices/device-details/device-details.component').then(
                (c) => c.DeviceDetailsComponent
            ),
    },
    {
        path: 'map-assets',
        loadComponent: () =>
            import('../helpers/components/map-assets/map-assets.component').then(
                (c) => c.MapAssetsComponent
            ),
    },
    {
        path: 'old',
        loadComponent: () =>
            import('../devices/device-list/device-list.component').then((c) => c.DeviceListComponent),
    },
]
